import { render, staticRenderFns } from "./DocumentacionEstudio.vue?vue&type=template&id=e603405a&"
import script from "./DocumentacionEstudio.vue?vue&type=script&lang=js&"
export * from "./DocumentacionEstudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports